// extracted by mini-css-extract-plugin
export default {"terms_and_conditions":"styles_terms_and_conditions__ajsUI"};